import {
  DateInput as RawDatePickerInput,
  DateInputProps as RawDatePickerInputProps,
} from '@mantine/dates';
import classNames from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import useCombinedRefs from 'hooks/use-combined-refs';
import { forwardRef, useRef } from 'react';

import styles from './styles.module.css';

import 'dayjs/locale/id';

dayjs.locale('id');
dayjs.extend(customParseFormat);

export interface DatePickerInputProps
  extends Omit<
    RawDatePickerInputProps,
    | 'inputWrapperOrder'
    | 'type'
    | 'format'
    | 'inputFormat'
    | 'labelFormat'
    | 'firstDayOfWeek'
    | 'radius'
    | 'dayClassname'
  > {
  type?: 'date';
  noMargin?: boolean;
}

const DatePicker = forwardRef<HTMLInputElement, DatePickerInputProps>(
  (props, ref) => {
    const innerRef = useRef<HTMLInputElement | null>(null);
    const combinedRef: any = useCombinedRefs(ref, innerRef);
    const {
      className,
      rightSection,
      defaultValue = new Date(),
      type,
      noMargin,
      disabled,
      readOnly,
      valueFormat = 'DD/MM/YYYY',
      ...rest
    } = props;

    const _disabled = disabled || readOnly;

    const dateParser = (value) => dayjs(value, valueFormat).toDate();

    return (
      <RawDatePickerInput
        ref={combinedRef}
        {...rest}
        dateParser={dateParser}
        defaultValue={defaultValue}
        inputWrapperOrder={['label', 'input', 'description', 'error']}
        className={classNames(styles.datePicker, className)}
        radius="md"
        firstDayOfWeek={0}
        valueFormat={valueFormat}
        readOnly={_disabled}
      />
    );
  },
);

DatePicker.displayName = 'DatePicker';

export default DatePicker;
